import { render, staticRenderFns } from "./DeletePhotoModal.vue?vue&type=template&id=956c41d4&scoped=true"
import script from "./DeletePhotoModal.vue?vue&type=script&lang=js"
export * from "./DeletePhotoModal.vue?vue&type=script&lang=js"
import style0 from "./DeletePhotoModal.vue?vue&type=style&index=0&id=956c41d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956c41d4",
  null
  
)

export default component.exports